import React from "react";
import BaseReportPage from "./_BaseReportPage";
import ConsolidatedReportUI from "../Components/ConsolidatedReport";

export default function ConsolidatedReportPage() {
  return (
    <BaseReportPage
      apiEndpoint="/hrms/attendance"
      title="Consolidated Report"
      emptyMessage="No records available"
      columns={[]}
      downloadEndpoint="/hrms/attendance/download"
      customTable={(rows) => <ConsolidatedReportUI data={rows} />}
    />
  );
}
